import { getCookie } from 'bv';
import format from './format';

const getCurrencyPart = (part) => () => {
  const cookieVal = getCookie(`currency_${part}`);

  return cookieVal ? decodeURIComponent(cookieVal) : '';
};

const suffix = getCurrencyPart('suffix');
const prefix = getCurrencyPart('prefix');

const parseAmount = (amount) => (
  amount < 0 ? { sign: '-', amount: Math.abs(amount) } : { sign: '', amount }
);

export default (amount, { withPaddedDecimals } = { withPaddedDecimals: false }) => {
  const { sign, amount: parsedAmount } = parseAmount(amount);

  return `${sign}${prefix()}${format(parsedAmount, { withPaddedDecimals })}${suffix()}`;
};
